import Collapse from '@mui/material/Collapse';
import Typography from '@mui/material/Typography';
import React, { CSSProperties } from 'react';


const styles: { [key: string]: CSSProperties } = {
  st0: {
    fill: '#ffffff',
    stroke: '#FFFFFF',
    strokeWidth: 10,
    strokeMiterlimit: 10
  },
  st1: {
    fill: '#59C7EE',
    // stroke: '#FFFFFF',
    strokeWidth: 0,
    strokeMiterlimit: 10
  },
  st3: {
    fill: 'none',
    stroke: '#FFFFFF',
    strokeWidth: 20,
    strokeMiterlimit: 10
  },
  st4: {
    fill: '#FFFFFF'
  },
  text: {}
};

function LogoNine() {
  return (
    <svg
      version="1.1"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 845 845"
      xmlSpace="preserve"
    >
      <g transform="translate(633.33563,158.67212)">
        <path style={styles.st0}
              d="M-511.6,657.9c0-0.2-1.2-1.6-2.7-3.2c-6.6-7-13.7-21.2-14.6-29.2c-0.1-1.3-0.5-2.6-0.7-2.8 c-0.6-0.5-0.2-21.8,0.5-22.3c0.2-0.2,0.7-1.7,1-3.2c0.6-2.7,4-12,4.8-13.1c0.2-0.3,0.6-0.8,0.8-1.2c0.7-1.4,3.1-5.4,3.7-6.1
          c0.3-0.4,0.9-1.2,1.2-1.8c0.3-0.6,0.9-1.4,1.3-1.8c0.4-0.4,1-1.3,1.5-1.8c4.1-5.4,16-15.4,21.5-17.9c0.5-0.2,1.3-0.7,1.9-1
          c2.2-1.2,2.9-1.5,5.4-2.7c3.5-1.5,3.7-1.6,4.1-1.9c0.2-0.1,1.2-0.5,2.3-0.8s2.1-0.6,2.2-0.7c1-0.6,9.4-2.6,12.3-3
          c2.1-0.3,3.3-0.8,2.8-1.2c-0.1-0.1-1.4-0.3-2.8-0.5c-3.4-0.4-9.8-2.1-15.5-4.2c-17.8-6.6-33.2-20.2-40.6-36
          c-2.3-4.8-4.4-11.2-4.7-14.2c-0.1-1.3-0.5-2.6-0.7-2.8c-0.6-0.5-0.2-21.8,0.5-22.3c0.2-0.2,0.7-1.7,1-3.2c0.6-2.7,4-12,4.8-13.1
          c0.2-0.3,0.6-0.8,0.8-1.2c0.7-1.4,3.1-5.4,3.7-6.1c0.3-0.4,0.8-1.1,1.1-1.5c0.3-0.4,1.1-1.5,1.8-2.4c0.8-0.9,1.4-1.8,1.5-1.9
          c0.1-0.5,5.3-5.8,7.9-8.1c3.4-3,10.6-8.1,13.1-9.3c0.5-0.2,1.3-0.7,1.9-1c0.6-0.3,1.4-0.8,1.9-1c0.7-0.4,3.7-1.7,7-3.1
          c0.4-0.2,0.8-0.4,0.9-0.5c0-0.1,1-0.4,2.1-0.6s2.1-0.6,2.2-0.7c1.4-0.7,7.9-2.3,14.1-3.4c4.1-0.7,25.5-1,26.2-0.3
          c0.2,0.2,1.5,0.5,2.9,0.7c9,1.1,24.1,6.9,32,12.5c12.8,8.9,21.4,19.6,26.2,32.3c2,5.3,2.5,7.2,2.9,10c0.2,1.2,0.5,2.3,0.7,2.5
          s0.4,4.7,0.2,10c-0.2,8.7-0.9,13.7-2.6,18l-0.6,1.5l120.8,0.1c119.3,0.1,203.2-0.1,201-2.1c-0.2-0.2-0.5-1.4-0.6-2.7
          s-0.5-2.6-0.7-2.8c-0.8-0.7-0.1-19.4,0.8-23.2c0.5-2,1-3.7,1.1-3.8c0.1-0.1,0.5-1.3,0.8-2.6c0.5-2.1,1.5-4.9,2.1-5.7
          c0.1-0.1,0.5-0.9,0.9-1.7c3.9-8.3,8.5-14.3,16.7-21.7c3.6-3.2,7.7-6.6,9.1-7.5c1.4-0.9,3.2-2,4-2.5c0.8-0.5,1.8-1,2.2-1.2
          c0.4-0.2,1.3-0.6,1.9-1c1.2-0.7,5.6-2.7,7.6-3.5c0.6-0.2,1.9-0.7,2.8-1s1.8-0.6,2-0.7c1.7-0.8,8-2.3,14.1-3.4
          c4.2-0.7,25.5-1,26.3-0.3c0.2,0.2,1.6,0.5,3,0.7c3.4,0.4,9.8,2.1,15.5,4.2c17.8,6.5,33.2,20.2,40.6,36c2.3,4.8,4.4,11.2,4.7,14.2
          c0.1,1.3,0.5,2.6,0.7,2.8c0.6,0.5,0.2,21.8-0.5,22.3c-0.2,0.2-0.7,1.7-1,3.2c-0.6,2.7-4,12-4.8,13.1c-0.2,0.3-0.6,0.8-0.8,1.2
          c-0.7,1.4-3.1,5.4-3.7,6.1c-0.3,0.4-0.9,1.2-1.2,1.8c-0.3,0.6-0.9,1.4-1.3,1.8c-0.4,0.4-1,1.3-1.5,1.8c-4.1,5.4-16,15.4-21.5,17.9
          c-0.5,0.2-1.3,0.7-1.9,1c-2.2,1.2-2.9,1.5-5.4,2.7c-3.5,1.5-3.7,1.6-4.1,1.9c-0.2,0.1-1.2,0.5-2.3,0.8c-1.1,0.3-2.1,0.6-2.2,0.7
          c-1,0.6-9.4,2.6-12.3,3c-2.1,0.3-3.3,0.8-2.8,1.2c0.1,0.1,1.4,0.3,2.8,0.5c3.4,0.4,9.8,2.1,15.5,4.2c17.8,6.6,33.2,20.2,40.6,36
          c2.3,4.8,4.4,11.2,4.7,14.2c0.1,1.3,0.5,2.6,0.7,2.8c0.6,0.5,0.2,21.8-0.5,22.3c-0.2,0.2-0.7,1.7-1,3.2c-0.6,2.7-4,12-4.8,13.1
          c-0.2,0.3-0.6,0.8-0.8,1.2c-0.7,1.4-3.1,5.4-3.7,6.1c-0.3,0.4-0.8,1.1-1.1,1.5s-1.1,1.5-1.8,2.4c-0.8,0.9-1.4,1.8-1.5,1.9
          c-0.1,0.5-5.3,5.8-7.9,8.1c-4.5,4-11.5,8.7-14.7,9.9c-1.1,0.4-2.2,1-2.3,1.2c-0.3,0.5-6.3,3.2-7.5,3.4c-0.5,0.1-0.8,0.2-0.6,0.3
          c0.1,0.1-0.6,0.5-1.7,0.8c-1.1,0.3-2.1,0.6-2.2,0.7c-1.4,0.7-7.9,2.3-14.1,3.4c-4.1,0.7-25.5,1-26.2,0.3c-0.2-0.2-1.5-0.5-2.9-0.7
          c-9-1.1-24.1-6.9-32-12.5c-12.8-8.9-21.4-19.6-26.2-32.3c-2-5.3-2.5-7.2-2.9-10c-0.2-1.2-0.5-2.3-0.7-2.5c-0.2-0.2-0.4-4-0.4-8.5
          l0-8.1l-198.5,0.1l-118.2-0.1l-0.3,7.1c-0.2,6-1.5,13.9-2.3,14.6c-0.1,0.1-0.5,1.3-0.8,2.6c-0.5,2.1-1.5,4.9-2.1,5.7
          c-0.1,0.1-0.5,0.9-0.9,1.7c-3.9,8.3-8.5,14.3-16.7,21.7c-3.6,3.2-7.7,6.6-9.1,7.5c-1.4,0.9-3.2,2-4,2.5c-0.8,0.5-1.8,1-2.2,1.2
          c-0.4,0.2-1.3,0.6-1.9,1c-1.2,0.7-5.6,2.7-7.6,3.5c-0.6,0.2-1.9,0.7-2.8,1c-0.9,0.3-1.8,0.6-2,0.7c-1.7,0.8-8,2.3-14.1,3.4
          c-4.2,0.7-25.5,1-26.3,0.3c-0.2-0.2-1.6-0.5-3-0.7c-8.3-0.9-23.9-7-31.6-12.3C-502.6,665.7-511.6,658.3-511.6,657.9L-511.6,657.9z"/>
      </g>
      <g>
        <polygon className="st1" style={styles.st1} points="421.2,0 138.2,422 421.2,845 704.2,422 	"/>
        <polygon className="st3" style={styles.st3} points="421.2,51.3 172.5,422.1 421.2,793.7 669.8,422.1 	"/>
        <g>
          <path className="st4"
                style={styles.st4}
                d="M328,517.1l59.8-6.6c1.5,12.2,5.3,21.2,11.4,27c6.2,5.9,14.3,8.8,24.4,8.8c12.7,0,23.6-5.9,32.5-17.6
              c8.9-11.7,14.6-36,17.1-72.9c-15.5,18-34.9,27-58.2,27c-25.3,0-47.2-9.8-65.6-29.3c-18.4-19.6-27.6-45-27.6-76.4
              c0-32.7,9.7-59,29.1-79c19.4-20,44.1-30,74.2-30c32.7,0,59.5,12.6,80.4,37.9c20.9,25.3,31.4,66.8,31.4,124.7
              c0,58.9-10.9,101.4-32.7,127.4c-21.8,26.1-50.2,39.1-85.3,39.1c-25.2,0-45.6-6.7-61.1-20.1C342.4,563.8,332.4,543.7,328,517.1z
               M467.8,382.2c0-19.9-4.6-35.4-13.7-46.4c-9.2-11-19.7-16.5-31.8-16.5c-11.4,0-20.9,4.5-28.5,13.5c-7.5,9-11.3,23.8-11.3,44.3
              c0,20.8,4.1,36.1,12.3,45.8c8.2,9.7,18.5,14.6,30.8,14.6c11.9,0,21.9-4.7,30-14.1C463.7,414.1,467.8,400.3,467.8,382.2z"/>
        </g>
      </g>
    </svg>
  );
}

export interface ILoading {
  hidden?: () => void;
  show: boolean;
  text?: string;
}

// background: (theme) => `linear-gradient(60deg, ${theme.palette.primary.main} 0%,${theme.palette.primary.dark} 100%)`,
//   color: '#fff'
export default function Loading(props: ILoading) {
  return (
    <Collapse in={props.show}>
      <div className="scout-loading hideable" style={{ position: 'fixed', top: 0 }}>
        <div className="logo logo-text">
          <LogoNine/>
        </div>
        <svg className="spinner" viewBox="25 25 50 50">
          <circle className="path" cx="50" cy="50" r="20" fill="none" strokeWidth={2} strokeMiterlimit={10}/>
        </svg>
        {
          props.text
            ? <Typography
              sx={{
                position: 'absolute',
                transform: 'translateY(160px)',
                color: '#FFFFFF'
              }}
              variant="body1"
            >{props.text}</Typography>
            : null
        }
      </div>
    </Collapse>
  );

}
